const initialState = {
  status: "invalid",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "MOVIES_CATEGORIES_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "MOVIES_CATEGORIES_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action
      };
    case "MOVIES_CATEGORIES_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
